import { COUNTRY_COOKIE_KEY, LANGUAGE_COOKIE_KEY } from '@crehana/constants';
import { type CountryCode, LANGUAGES } from '@crehana/ts-types';
import { cookies } from '@crehana/utils';

const getCookieValues = (): {
  language: LANGUAGES;
  country: CountryCode;
} => {
  if (typeof window === 'undefined') {
    return {
      language: LANGUAGES.ES,
      country: '*',
    };
  }

  const browserCookies = cookies.getAll();

  const language = (browserCookies[LANGUAGE_COOKIE_KEY] as LANGUAGES) || null;
  const country = (browserCookies[COUNTRY_COOKIE_KEY]?.toLocaleLowerCase() ||
    '*') as CountryCode;

  return {
    language,
    country,
  };
};

export const { language } = getCookieValues();
